module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-driver-license-attachment-upload"
  }, [_c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.dropzoneUrl
    },
    on: {
      "vdropzone-success": _vm.uploaded,
      "vdropzone-removed-file": _vm.removeAttachment
    }
  }), _c('button', {
    staticClass: "button expanded",
    class: {
      disabled: _vm.attachments.length === 0
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Save and Submit")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c239f94!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverLicenseAttachmentUpload.vue
// module id = 2422
// module chunks = 1